import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomerInfoComponent } from '../customer-info/customer-info.component';

@Component({
    selector: 'app-customer-info-wrapper',
    templateUrl: './customer-info-wrapper.component.html',
    styleUrls: ['./customer-info-wrapper.component.scss'],
    standalone: true,
    imports: [CustomerInfoComponent]
})
export class CustomerInfoWrapperComponent {

    constructor(
        private dialogRef: MatDialogRef<CustomerInfoWrapperComponent>
    ) { }

    close() {
        this.dialogRef.close();
    }
}
